import React, { useCallback, useState } from "react";
import styled from "styled-components";

import { AssessmentTriggerModalV2 } from "../../../../components/common/AIModals";
import {
  Card,
  RowContainer,
} from "../../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../../components/common/styledComponents";
import { CompassAIButton } from "../../../../components/buttons/styledComponents";
import { darkGreen, greyText } from "../../../../styles";

import engagementRatingIllustration from "../../../../assets/images/engagement_rating.png";

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 16px;
  max-width: 480px;
`;

const Illustration = styled.img`
  width: 180px;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

export const AssessmentEmptyState = ({
  engagementRecordId,
  onSingleComplete,
}: AssessmentEmptyStateProps): JSX.Element => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = useCallback((): void => {
    setShowModal(true);
  }, []);

  const handleClose = useCallback((): void => {
    setShowModal(false);
  }, []);

  const handleSingleComplete = useCallback(
    (completedId: string): void => {
      onSingleComplete(completedId);
    },
    [onSingleComplete],
  );

  return (
    <RowContainer ml={10} mt={20} jc="center">
      <Card w={60} h="auto" p="40px">
        <RowContainer jc="center" mt={0} mb={0}>
          <EmptyStateContent>
            <Illustration
              src={engagementRatingIllustration}
              alt=""
              aria-hidden="true"
            />
            <CompassParagraph
              bold
              fontSize={16}
              color={darkGreen}
              ta="center"
              mt={4}
            >
              No assessments yet for this engagement
            </CompassParagraph>
            <CompassParagraph
              fontSize={13}
              color={greyText}
              ta="center"
              mb={8}
            >
              Run the AI-powered v2 assessment to grade this engagement across
              six quality pillars and surface any engagement sins.
            </CompassParagraph>
            <CompassAIButton
              variant="filled"
              onClick={handleOpen}
              $padding="10px 32px"
            >
              <span>Run assessment</span>
            </CompassAIButton>
          </EmptyStateContent>
        </RowContainer>
      </Card>

      <AssessmentTriggerModalV2
        show={showModal}
        onClose={handleClose}
        mode="single"
        engagementRecordId={engagementRecordId}
        onSingleComplete={handleSingleComplete}
      />
    </RowContainer>
  );
};

type AssessmentEmptyStateProps = {
  engagementRecordId: string;
  onSingleComplete: (engagementRecordId: string) => void;
};
